import type { ReactElement } from 'react';
import type { UserType } from '@kirin/api-client/contracts/user';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

export interface UserTypeTagProps {
  userType?: UserType | null;
  className?: string;
}

/**
 * KIR-3908: small tag next to a user in the Alerts views.
 * - `discovered` → "Discovered" (a Cowork user with no Kirin account).
 * - `unattributed` → "No email" (the per-org placeholder for a missing/invalid
 *   acting email; the label itself already reads "Unattributed").
 * `full` (or absent) renders nothing.
 */
export function UserTypeTag({
  userType,
  className,
}: UserTypeTagProps): ReactElement | null {
  if (userType === 'discovered') {
    return (
      <Badge
        variant="outline"
        className={cn(
          'border-blue-300 text-blue-700 dark:border-blue-700 dark:text-blue-300',
          className
        )}
      >
        Discovered
      </Badge>
    );
  }
  if (userType === 'unattributed') {
    return (
      <Badge
        variant="outline"
        className={cn('text-muted-foreground', className)}
      >
        No email
      </Badge>
    );
  }
  return null;
}

UserTypeTag.displayName = 'UserTypeTag';
